<quill-editor class="w-100"
              [(ngModel)]="currentDescription"
              [modules]="modules"
              placeholder="Fill in description"
              i18n-placeholder="@@resource.description"
              theme="bubble">
</quill-editor>
